export const MuiSelect = (palette) => ({
  defaultProps: {
    native: true,
  },
  styleOverrides: {
    root: {
      width: '100%',
      padding: '8px 12px 8px 8px',
      borderRadius: '8px',
      border: `1px solid ${palette.neutral[300]}`,
      boxSizing: 'border-box',
      'label + &': {
        marginTop: '20px',
      },
      '&::before': {
        content: 'none',
      },
      '&::after': {
        content: 'none',
      },
      '&.MuiInputBase-sizeSmall': {
        height: '41px',
        padding: '7px 12px 7px 8px',
        boxSizing: 'border-box',
        '& .MuiNativeSelect-select': {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box',
        },
      },
    },
    select: {
      border: 0,
      padding: 0,
      lineHeight: '24px',
      borderRadius: '8px',
      background: '#ffffff',
      '&.MuiNativeSelect-select': {
        boxSizing: 'border-box',
      },
    },
  },
});
